import React from "react";
import { createElementClass, createModifierClass } from "../../helpers";
export var Tab = function Tab(_a) {
  var _b = _a.label,
      label = _b === void 0 ? "" : _b,
      tabIndex = _a.tabIndex,
      _c = _a.isActive,
      isActive = _c === void 0 ? false : _c,
      parentCallback = _a.parentCallback;
  return React.createElement("li", {
    className: createElementClass("tab") + " " + (isActive ? createModifierClass("active", "tab") : ""),
    key: tabIndex
  }, React.createElement("div", {
    className: createElementClass("tab-label"),
    onClick: function onClick(event) {
      event.preventDefault();
      parentCallback && parentCallback(tabIndex);
    }
  }, label));
};